/**
 * Helper function to format a JSON string with specified indentation.
 *
 * @param input - The JSON input to format
 * @param indentation - The indentation level or string to use for formatting
 * @returns string
 */
export const formatJson = (input: string, indentation: number = 2): string => {
  try {
    const parsed = JSON.parse(input.trim());
    return JSON.stringify(parsed, null, indentation);
  } catch {
    return input;
  }
};
